//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UiLinkApp',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    queryParams() {
      const { ref, partner } = this.$route.query;
      return { ref, partner };
    },
  }
}
